document.addEventListener("DOMContentLoaded", () => {
  const targetCart = document.querySelector("search-drawer");
  if (targetCart) {
    const mutationObserver = new MutationObserver(
      async (recordList, observe) => {
        for (const record of recordList) {
          if (record.target.classList.contains("predictive-search")) {
            if(!BSS_B2B) return;
            const res = await BSS_B2B.storage.productStorage.load();
            document.dispatchEvent(
              new CustomEvent(`bss_b2b:SearchBarLoaded`, {
                bubbles: true,
                detail: res,
              })
            );
            break;
          }
        }
      }
    );
    mutationObserver.observe(targetCart, { childList: true, subtree: true });
  }
});
